export default "__VITE_ASSET__4e2680c9__"